<template>
    <v-card v-if="order">
        <v-container dense>
            <v-row dense>
                <template v-if="order.streamId">
                    <v-col cols="12">
                        <v-row justify="center">
                            <v-col cols="auto" style="min-height: 240px;">
                                <img class="live-video" :src="order.getStreamUrl()"/>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-divider/>
                    </v-col>
                </template>

                <v-col cols="12">
                    <v-row justify="space-between" no-gutters>
                        <v-col class="overline font-weight-bold grey--text" cols="auto">
                            <template v-if="car">
                                Автомобиль
                            </template>
                            <template v-else>
                                Пробег
                            </template>
                        </v-col>
                        <v-col class="overline font-weight-bold primary--text" cols="auto">
                            {{ dateFormatted }}
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="auto">
                            <div class="text-center">
                                <template v-if="car">
                                    <div class="display-1">{{ car.model }}</div>
                                    <div class="headline">{{ car.numberPlate }}</div>
                                </template>
                                <template v-else>
                                    <div class="display-1">{{ order.mileage }} км</div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-divider/>
                </v-col>

                <v-col cols="12">
                    <div class="headline">{{ timeFormatted }}</div>
                </v-col>
                <v-col cols="12">
                    <v-divider/>
                </v-col>

                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Заказ-наряд
                    </div>
                    <div>
                        № {{ order.id }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        СТО
                    </div>
                    <div>
                        {{ order.station }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Работа
                    </div>
                    <div v-if="order.works">
                        <v-row
                            v-for="work in order.works"
                            :key="`work_${work.id}`"
                            dense
                            justify="space-between"
                        >
                            <v-col cols="auto">
                                {{ work.name }}
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Материал
                    </div>
                    <div v-if="order.items">
                        <v-row
                            v-for="item in order.items"
                            :key="`item_${item.id}`"
                            dense
                            justify="space-between"
                        >
                            <v-col cols="auto">
                                <span>{{ item.name }}</span>
                                <span class="ml-2 grey--text">x {{ item.quantity }}</span>
                            </v-col>
                            <v-col cols="auto">{{ item.sum | currency }}</v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                </v-col>
                <v-col cols="12">
                    <v-divider/>
                </v-col>

                <v-col cols="12">
                    <v-btn block color="secondary" :disabled="isCanceling" :loading="isCanceling" @click="cancelOrder">
                        Отменить заказ
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        name: 'OrderStationItem',

        props: {
            order: { type: Object },
            car: { type: Object },
        },

        computed: {
            ...mapState('order', {
                isCanceling: (state) => state.isCanceling,
            }),

            dateFormatted() {
                const unix = this.order?.date

                if (unix) {
                    return moment.unix(unix).utcOffset(5).locale('ru').format('LL')
                } else {
                    return null
                }
            },

            timeFormatted() {
                const unix = this.order?.date

                if (unix) {
                    return moment.unix(unix).utcOffset(5).locale('ru').format('HH:mm')
                } else {
                    return null
                }
            },
        },

        methods: {
            cancelOrder() {
                if (window.confirm('Отменить заказ?')) {
                    const orderId = this.order?.id
                    const orderDate = this.order?.date

                    this.$store.dispatch('order/cancelOrder', {
                        orderId,
                        orderDate,
                    })
                        .then(() => {
                            this.$store.dispatch('order/fetch')
                        })
                        .catch(() => {
                            //
                        })
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .live-video {
        width: 100%;
    }
</style>
